export const palette = {
  id: 'sakura',
  displayName: 'Sakura',
  graph: {
    writeSample: '#E8849A', writeTrend: 'rgba(232, 132, 154, 0.67)',
    writeMax: '#F5C2CE', writeMin: '#A83060', writeLatency: '#E8849A',
    readSample: '#7A9E7E', readTrend: 'rgba(122, 158, 126, 0.67)',
    readMax: '#B0CCAA', readMin: '#4A6B4D', readLatency: '#7A9E7E',
  },
  canvas: {
    chartBg: '#FFFBFC', gridColor: '#EEEEEE', textColor: '#2D1B22',
  },
};

const sakura = {
  id: 'sakura',
  displayName: 'Sakura',
  baseType: 'light',
  enabled: false,
  linkedPalette: 'sakura',
  palette,
  ui: {
    headerBg: '#FFFBFC', headerText: '#2D1B22', accentColor: '#D4607C',
    mainBg: '#FCEEF2', mainText: '#2D1B22', mainTextHeading: '#2D1B22',
    mainHeroText: '#FFFFFF', footerBg: '#FFFBFC', footerText: '#2D1B22',
    cardBg: '#FFFFFF', cardText: '#2D1B22', cardBorder: '#D4607C',
    cardButtonBg: '#D4607C', cardButtonText: '#FFFFFF',
    navLinkText: '#2D1B22', navLinkHover: '#D4607C', navLinkActive: '#2D1B22',
    listGroupBg: '#FCEEF2', bmrkDetailBg: '#D4607C',
    bmrkMetricBg: '#FFFFFF', bmrkMetricText: '#2D1B22', bmrkMetricBorder: '#D4607C',
    mainCardText: '#2D1B22', navLinkFocus: '#2D1B22', navEmailActive: '#2D1B22',
    homeProseLabel: '#D4607C', homeProseLink: '#2D1B22', homeProseDlBtn: '#2D1B22',
    cardButtonBorder: '#D4607C', linkColor: '#D4607C', cardTextMuted: '#706469',
  },
};
export default sakura;
